import { Component, Vue, Watch } from 'vue-property-decorator';
import RecapService from '@/service/recap.service';
import ScrapAgentService from '@/service/scrap-agent.service';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ListLoading from '@/entities/resource-management/list-loading/list-loading.vue';
import moment from 'moment';
import { formatDateAgo } from '@/util/date-util';
import ReportToastUtil from '@/util/report-toast.util';
import { LOADING_DATA_TYPE, REPORT_TOAST_STATUS } from '@/constants';
import { namespace } from 'vuex-class';
import BriefingService from '@/service/briefing.service';
import { checkIsGuestAccount } from '@/util/guest-util';
import { IResourceModel } from '@/shared/model/briefing-widget.model';
import LoadingReportCardComponent from '@/shared/cards/loading-card/loading-report-card/loading-report-card.vue';

const { CalendarPanel } = DatePicker;
const appStoreState = namespace('appStore');

@Component({
  computed: {
    moment() {
      return moment;
    },
  },
  components: {
    DatePicker,
    CalendarPanel,
    ListLoading,
    LoadingReportCardComponent,
  },
  methods: {
    formatDateAgo,
  },
})
export default class MyCreatePodcast extends Vue {
  @appStoreState.Getter
  public getReShowToastReport!: boolean;

  @appStoreState.Mutation
  public setReShowToastReport!: (payload: boolean) => void;

  @appStoreState.Getter
  public getToastReportData!: any;

  recapService = new RecapService();
  scrapAgentService = new ScrapAgentService();
  briefingService = new BriefingService();

  userKey = '';
  mediaType = '';
  pageNumber = 0;
  pageSize = 12;
  searchQuery = '';
  selectedPeriod = 'All';
  selectedLanguage = 'All Languages';
  dateRange = '';
  isPlaying = false;
  audio: HTMLAudioElement | null = null;
  podcastEnabled = true;
  totalTime = 0;
  playerProgress = 0;
  currentTime = 0;
  currentPlayingId: string | null = null;
  selectedTab = 'All';
  totalElementPodcast = 0;
  weeklyGooverCount = 0;
  dailyGooverCount = 0;

  showDatePicker = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  dateRangeValue: Date[] = [];
  isDropdownOpen = false;
  innerValue: Date[] = [new Date(NaN), new Date(NaN)];

  isLoading = false;
  isLoadingMore = false;
  hasMoreData = true;
  private debounceTimer: number | null = null;

  bookmarkedPodcasts: { [key: string]: boolean } = {};
  checkPodcastData = false;
  initialLoading = true;

  podcasts: any[] = [];
  intervalRemoveLoadingPodcastData;
  isAudioLoading = false;
  downloadStatus = false;

  private audioInstance: HTMLAudioElement | null = null;
  private globalAudioState = {
    currentPlayingId: null as string | null,
    isPlaying: false,
    currentAudioUrl: '',
  };
  loadingList: IResourceModel[] = [];

  get periods() {
    return [
      { key: 'All', value: this.$t('my-create.podcast.all') as string },
      { key: '1day', value: this.$t('my-create.podcast.day') as string },
      { key: '1week', value: this.$t('my-create.podcast.week') as string },
      { key: '1month', value: this.$t('my-create.podcast.1month') as string },
      { key: '3months', value: this.$t('my-create.podcast.3month') as string },
      { key: '6months', value: this.$t('my-create.podcast.6month') as string },
      { key: '1year', value: this.$t('my-create.podcast.year') as string },
      { key: 'Choose period', value: this.$t('my-create.podcast.choosePeriod') as string },
    ];
  }

  get languages() {
    return [
      { key: 'All Languages', value: this.$t('my-create.podcast.allLanguages') as string },
      { key: 'Korean', value: this.$t('my-create.podcast.korean') as string },
      { key: 'English', value: this.$t('my-create.podcast.english') as string },
    ];
  }

  get selectedLanguageDisplay(): string {
    const langMap = {
      'All Languages': this.$t('my-create.podcast.allLanguages'),
      Korean: this.$t('my-create.podcast.korean'),
      English: this.$t('my-create.podcast.english'),
    };
    return langMap[this.selectedLanguage] || this.$t('my-create.podcast.allLanguages');
  }

  getClasses(cellDate, currentDates, classes) {
    if (
      !/disabled|active|not-current-month/.test(classes) &&
      currentDates.length === 2 &&
      cellDate.getTime() > currentDates[0].getTime() &&
      cellDate.getTime() < currentDates[1].getTime()
    ) {
      return 'in-range';
    }
    return '';
  }

  handleSelect(date) {
    const [startValue, endValue] = this.innerValue;
    if (this.isValidDate(startValue) && !this.isValidDate(endValue)) {
      if (startValue.getTime() > date.getTime()) {
        this.innerValue = [date, startValue];
      } else {
        this.innerValue = [startValue, date];
      }
      this.dateRangeValue = this.innerValue;

      this.isDropdownOpen = false;

      this.closeDatePicker();
    } else {
      this.innerValue = [date, new Date(NaN)];
    }
  }

  handleSearch() {
    if (this.searchQuery.trim()) {
      this.pageNumber = 0;
      this.hasMoreData = true;
      this.getAllPodcastByUser();
    }
  }

  private closeDatePicker() {
    const datePicker = this.$refs.datePickerRef as any;
    if (datePicker && datePicker.closePopup) {
      datePicker.closePopup();
    } else if (datePicker && datePicker.$el) {
      const input = datePicker.$el.querySelector('.mx-input');
      if (input) input.blur();
    }
  }

  private isValidDate(date: any): boolean {
    return date instanceof Date && !isNaN(date.getTime());
  }

  get dropdownButtonText(): string {
    const selected = this.periods.find(p => p.key === this.selectedPeriod);
    if (selected && selected.key !== 'Choose period') {
      return selected.value;
    }

    if (this.dateRangeValue.length === 2 && this.dateRangeValue[0] && this.dateRangeValue[1]) {
      const start = this.formatDateForDisplay(this.dateRangeValue[0]);
      const end = this.formatDateForDisplay(this.dateRangeValue[1]);
      return `${start} ~ ${end}`;
    }

    return this.$t('my-create.podcast.choosePeriod') as string;
  }

  openDatePicker() {
    if (this.selectedPeriod === 'Choose period' && !this.showDatePicker) {
      this.showDatePicker = true;

      if (!this.dateRangeValue.length) {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - 7);
        this.dateRangeValue = [startDate, endDate];
      }
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  applyCustomDateFilter() {
    this.pageNumber = 0;
    this.hasMoreData = true;
    this.getAllPodcastByUser();
  }

  selectPeriod(period: string): void {
    this.selectedPeriod = period;

    if (period !== 'Choose period') {
      this.isDropdownOpen = false;
      this.applyDateFilter();
    } else {
      this.dateRangeValue = [this.startDate, this.endDate];
      this.isDropdownOpen = true;
    }
  }

  selectLanguage(lang: string): void {
    this.selectedLanguage = lang;
    this.pageNumber = 0;
    this.hasMoreData = true;
    this.getAllPodcastByUser();
  }

  formatDateForDisplay(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}.${month}.${day}`;
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }

  selectTab(tab: string) {
    this.selectedTab = tab;
    this.pageNumber = 0;
    this.hasMoreData = true;

    switch (tab) {
      case 'Daily Goover':
        this.mediaType = 'DAILY';
        break;
      case 'Weekly Goover':
        this.mediaType = 'WEEKLY';
        break;
      default:
        this.mediaType = '';
        this.selectedTab = 'All';
    }

    this.getAllPodcastByUser();
  }

  disableFutureDates(date: Date) {
    return date > new Date();
  }

  applyDateFilter() {
    this.pageNumber = 0;
    this.hasMoreData = true;
    this.getAllPodcastByUser();
  }

  created() {
    this.audioInstance = new Audio();
    this.audioInstance.onended = () => {
      this.globalAudioState.isPlaying = false;
      this.globalAudioState.currentPlayingId = null;
      this.currentPlayingId = null;
      this.isPlaying = false;
    };
  }

  beforeDestroy() {
    if (this.audioInstance) {
      this.audioInstance.pause();
      this.audioInstance.src = '';
      this.audioInstance = null;
    }
  }

  async mounted() {
    const userData = this.getLocalStorageUser();
    if (userData) {
      this.userKey = userData.id;
    }
    const dailyCount = await this.countPodcast('DAILY');
    this.dailyGooverCount = typeof dailyCount === 'number' ? dailyCount : 0;

    const weeklyCount = await this.countPodcast('WEEKLY');
    this.weeklyGooverCount = typeof weeklyCount === 'number' ? weeklyCount : 0;
    this.initialLoading = true;
    await this.getAllPodcastByUser();
    await this.initializeAudio();
    await this.setupInfiniteScrollObserver();
  }

  @Watch('getToastReportData')
  onGetToastReportData() {
    console.log('getToastReportData changed:', this.getToastReportData);
    this.getToastReportData.forEach(data => {
      if (
        data.type === 'PODCAST' &&
        data.status === REPORT_TOAST_STATUS.LOADING &&
        !this.loadingList.some(item => item.requestId === data.requestId)
      ) {
        const loadingData: IResourceModel = {
          requestId: data.requestId,
          isLoadingCard: true,
          docId: '',
          type: 'PODCAST',
        };
        this.loadingList.push(loadingData);
        console.log('loadingList updated:', this.loadingList);
      }
      if (data.status === REPORT_TOAST_STATUS.SUCCESS) {
        this.loadingList = this.loadingList.filter(item => item.requestId !== data.requestId);
      }
    });
  }

  async countPodcast(mediaType: string) {
    const response = await this.recapService.countPodcast(this.userKey, 'PODCAST', mediaType);
    if (response) {
      return response.body.countPodcast;
    }
  }

  private infiniteScrollObserver: IntersectionObserver | null = null;

  setupInfiniteScrollObserver() {
    if (this.infiniteScrollObserver) {
      this.infiniteScrollObserver.disconnect();
    }

    this.infiniteScrollObserver = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && this.hasMoreData && !this.isLoadingMore && !this.isLoading) {
          this.getAllPodcastByUser(true);
        }
      },
      {
        root: null,
        rootMargin: '200px',
        threshold: 0.1,
      }
    );

    this.$nextTick(() => {
      const oldSentinel = document.getElementById('scroll-sentinel');
      if (oldSentinel) {
        oldSentinel.remove();
      }
      const sentinel = document.createElement('div');
      sentinel.id = 'scroll-sentinel';
      sentinel.style.height = '1px';
      sentinel.style.width = '100%';
      document.querySelector('.go-section-body')?.appendChild(sentinel);

      if (sentinel && this.infiniteScrollObserver) {
        this.infiniteScrollObserver.observe(sentinel);
      }
    });
  }

  private initializeAudio() {
    this.audio = new Audio();
    this.audio.preload = 'none';

    this.audio.onloadeddata = () => {
      this.isAudioLoading = false;
    };

    this.audio.onended = () => {
      this.isPlaying = false;
      this.currentPlayingId = null;
    };
    this.audio.ontimeupdate = this.updateProgress;
  }

  private getLocalStorageUser(): any {
    try {
      const userData = localStorage.getItem('localStorageUser');
      return userData ? JSON.parse(userData) : null;
    } catch (e) {
      console.error('Error parsing user data:', e);
      return null;
    }
  }

  private async getAllPodcastByUser(loadMore = false): Promise<void> {
    if (this.isLoading || (loadMore && this.isLoadingMore)) return;

    if (!loadMore) {
      this.pageNumber = 0;
      this.hasMoreData = true;
      this.isLoading = true;
    } else {
      if (!this.hasMoreData) return;
      this.isLoadingMore = true;
      this.pageNumber++;
    }

    try {
      const data = await this.briefingService.getAllBriefingDataForMycreate(
        null,
        ['PODCAST'],
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.pageNumber,
        this.pageSize,
        this.userKey,
        this.userKey,
        null,
        [this.mediaType],
        null
      );

      const response = data?.data?.body?.body?.discoveryReportDTO;

      this.totalElementPodcast = data?.data?.body?.body?.totalElements ?? 0;

      const totalPages = Math.ceil(this.totalElementPodcast / this.pageSize);

      this.hasMoreData = this.pageNumber < totalPages - 1;
      if (response?.listBriefingData.length > 0) {
        this.checkPodcastData = true;
        const newPodcasts = response?.listBriefingData || [];

        if (loadMore) {
          this.podcasts = [...this.podcasts, ...newPodcasts];
        } else {
          this.podcasts = newPodcasts;
        }

        newPodcasts.forEach(podcast => {
          if (
            podcast &&
            typeof podcast === 'object' &&
            podcast._id &&
            this.bookmarkedPodcasts &&
            !Object.prototype.hasOwnProperty.call(this.bookmarkedPodcasts, podcast._id)
          ) {
            this.$set(this.bookmarkedPodcasts, podcast._id, podcast.is_bookmarked || false);
          }
        });

        setTimeout(() => {
          this.handleRemoveLoadingPodcastData();
        }, 10);

        this.$nextTick(() => {
          this.setupInfiniteScrollObserver();
        });

        if (newPodcasts.length < this.pageSize) {
          this.hasMoreData = false;
        }
      } else {
        this.checkPodcastData = false;
        this.hasMoreData = false;
      }
    } catch (error) {
      console.error('Get all podcast error: ', error);
      if (loadMore) {
        this.pageNumber--;
      }
      this.checkPodcastData = false;
    } finally {
      this.isLoading = false;
      this.isLoadingMore = false;
      this.initialLoading = false;
    }
  }

  async togglePlay(url: string, podcastId: string): Promise<void> {
    if (!this.audioInstance) {
      this.audioInstance = new Audio();
      this.audioInstance.onended = () => {
        this.globalAudioState.isPlaying = false;
        this.globalAudioState.currentPlayingId = null;
        this.currentPlayingId = null;
        this.isPlaying = false;
      };
    }

    if (this.globalAudioState.currentPlayingId && this.globalAudioState.currentPlayingId !== podcastId) {
      this.audioInstance.pause();
      this.audioInstance.currentTime = 0;
    }

    try {
      if (this.globalAudioState.currentPlayingId === podcastId) {
        if (this.globalAudioState.isPlaying) {
          await this.audioInstance.pause();
        } else {
          await this.audioInstance.play();
        }
        this.globalAudioState.isPlaying = !this.globalAudioState.isPlaying;
      } else {
        this.audioInstance.src = url;
        await this.audioInstance.play();
        this.globalAudioState.currentPlayingId = podcastId;
        this.globalAudioState.isPlaying = true;
      }

      this.currentPlayingId = this.globalAudioState.currentPlayingId;
      this.isPlaying = this.globalAudioState.isPlaying;
    } catch (error) {
      if (error.name === 'NotAllowedError') {
        this.showToast(this.$t('my-create.podcast.playbackBlocked') as string, this.$t('common.error') as string, 'danger');
      }
    }
  }

  async copyPodcastUrl(url: string) {
    if (!url) return;

    try {
      await navigator.clipboard.writeText(url);
      this.showToast('URL copied successfully.', 'Success', 'success');
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
  }

  async downloadPodcast(url: string, title: string) {
    if (!url) return;

    this.downloadStatus = true;

    try {
      const fileResponse = await fetch(url);
      if (!fileResponse.ok) throw new Error('Failed to fetch file');
      const blob = await fileResponse.blob();

      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${title}.mp3`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      this.downloadStatus = false;
    }
  }

  private showToast(message: string, title: string, variant = 'info'): void {
    this.$bvToast.toast(message, {
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: 5000,
      toaster: 'b-toaster-bottom-right',
      noCloseButton: false,
      appendToast: true,
    });
  }

  async bookmark(podcastId) {
    if (checkIsGuestAccount(true)) {
      return;
    }

    const podcast = this.podcasts.find(p => p._id === podcastId);
    if (!podcast) {
      console.error('Podcast not found');
      return;
    }

    this.$set(this.bookmarkedPodcasts, podcastId, !this.bookmarkedPodcasts[podcastId]);

    const podcastData = podcast.parentDocDetail;

    const recap_info = {
      recap_id: podcastData.recap_id,
      ...podcastData.other_info,
    };

    const requestBody = [
      {
        requestId: podcast.requestId,
        title: podcastData.title,
        path: podcastData.source_uri,
        description: '',
        content: '',
        type: podcastData.media_type[0],
        collector: 'UW',
        userKey: this.userKey,
        originDate: '',
        searchTypes: [],
        mediaType: podcastData.media_type,
        imageUri: [],
        imageUriThumbnail: '',
        favicon: '',
        img: '',
        lang: podcastData.service_language,
        liked: 0,
        keyword: '',
        getMlEntity: [],
        getMlEntitySearch: [],
        requestBy: '',
        parentDocId: podcastId,
        parentDocIds: [podcastId],
        forcedClustering: true,
        requestedResourceList: [],
        targetBpId: '',
        titleBriefingPage: '',
        isFeed: true,
        htmlRaw: '',
        publishedAt: podcast.published_at,
        serviceHtml: '',
        ownerUserKey: '',
        sameBriefingPage: true,
        docType: 11,
        isInsideGroup: false,
        isGroup: false,
        originType: '',
        chunkId: '',
        chunkText: '',
        _id: '',
        created_at: '',
        writer: [],
        author: 'Goover',
        searchType: '',
        isBookmarked: this.bookmarkedPodcasts[podcastId],
        collectedQuality: '',
        other_info: recap_info,
      },
    ];

    await this.scrapAgentService.saveDefaultScrapAgentByType(this.userKey, requestBody);
  }

  updateProgress(): void {
    if (!this.audio) return;
    this.playerProgress = (this.audio.currentTime / this.totalTime) * 100;
    this.currentTime = this.audio.currentTime;
  }

  get formattedSpeakers() {
    return (speakers: any[]) => {
      if (!speakers || !speakers.length) return '';

      const host = speakers.find(s => s.speaker_role === 'host');
      const guest = speakers.find(s => s.speaker_role === 'guest');

      const result = [];
      if (host) result.push(host.speaker_nm);
      if (guest) result.push(guest.speaker_nm);

      return result.join(', ');
    };
  }

  get filteredPodcasts() {
    let filtered = [...this.podcasts];

    if (this.mediaType) {
      filtered = filtered.filter(podcast => podcast.parentDocDetail.media_type.includes(this.mediaType));
    }

    if (this.selectedPeriod !== 'All') {
      const range = this.getDateRange();
      if (range && range.start && range.end) {
        range.end.setHours(23, 59, 59, 999); // Đảm bảo cuối ngày
        filtered = filtered.filter(p => {
          const pubDate = new Date(p.published_at);
          return pubDate >= range.start && pubDate <= range.end;
        });
      }
    }

    if (this.selectedLanguage !== 'All Languages') {
      filtered = filtered.filter(podcast => {
        const lang = podcast.parentDocDetail.service_language;
        if (this.selectedLanguage === 'Korean') {
          return lang === 'KR' || lang === 'KOREAN';
        } else if (this.selectedLanguage === 'English') {
          return lang === 'EN' || lang === 'ENGLISH';
        }
      });

      return filtered;
    }

    if (this.selectedPeriod !== 'All') {
      const range = this.getDateRange();
      if (range) {
        range.end.setHours(23, 59, 59, 999);
        filtered = filtered.filter(p => {
          const pubDate = new Date(p.published_at);
          return pubDate >= range.start && pubDate <= range.end;
        });
      }
    }

    return filtered;
  }

  private getDateRange(): { start: Date; end: Date } | null {
    if (this.selectedPeriod === 'Choose period') {
      if (!this.dateRangeValue || this.dateRangeValue.length !== 2 || !this.dateRangeValue[0] || !this.dateRangeValue[1]) {
        return null; // Trả về null nếu ngày không hợp lệ
      }
      return {
        start: new Date(this.dateRangeValue[0]),
        end: new Date(this.dateRangeValue[1]),
      };
    }

    const endDate = new Date();
    const startDate = new Date();

    switch (this.selectedPeriod) {
      case '1day':
        startDate.setDate(endDate.getDate() - 1);
        break;
      case '1week':
        startDate.setDate(endDate.getDate() - 7);
        break;
      case '1month':
        startDate.setMonth(endDate.getMonth() - 1);
        break;
      case '3months':
        startDate.setMonth(endDate.getMonth() - 3);
        break;
      case '6months':
        startDate.setMonth(endDate.getMonth() - 6);
        break;
      case '1year':
        startDate.setFullYear(endDate.getFullYear() - 1);
        break;
      default:
        return null;
    }

    return { start: startDate, end: endDate };
  }

  goHome() {
    this.$router.push('/home');
  }

  showRecap(recapId) {
    if (!recapId) return;
    this.$router.push({
      name: 'MyRecap',
      query: {
        recapId: recapId,
      },
    });
  }

  convertRecapType(type) {
    try {
      switch (type) {
        case 'WEEKLY':
          return this.$t('my-create.podcast.weekly');
        case 'DAILY':
          return this.$t('my-create.podcast.daily');
        case 'WIZARD':
          return this.$t('my-create.podcast.wizard');
        default:
          return '';
      }
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  handleRemoveLoadingPodcastData() {
    try {
      if (this.podcasts?.length > 0) {
        let countTimes = 0;
        const reportToastUtil = new ReportToastUtil();

        if (this.intervalRemoveLoadingPodcastData) {
          clearInterval(this.intervalRemoveLoadingPodcastData);
          this.intervalRemoveLoadingPodcastData = null;
        }

        this.intervalRemoveLoadingPodcastData = setInterval(() => {
          if (this.podcasts?.length > 0) {
            const tempList = this.podcasts.filter(
              item =>
                item?.documentType === LOADING_DATA_TYPE.PODCAST.toString() &&
                item?.parentDocDetail &&
                (item.isLoadingCard === undefined || item.isLoadingCard === false)
            );

            if (tempList?.length > 0) {
              if (reportToastUtil && typeof reportToastUtil.handleRemoveLoadingPodcastToastWithListInput === 'function') {
                reportToastUtil.handleRemoveLoadingPodcastToastWithListInput(tempList);
              }

              countTimes++;

              if (countTimes >= 10) {
                clearInterval(this.intervalRemoveLoadingPodcastData);
                this.intervalRemoveLoadingPodcastData = null;
                this.setReShowToastReport(!this.getReShowToastReport);
              }
            }
          }
        }, 100);

        setTimeout(() => {
          if (this.intervalRemoveLoadingPodcastData) {
            this.setReShowToastReport(!this.getReShowToastReport);
          }

          clearInterval(this.intervalRemoveLoadingPodcastData);
          this.intervalRemoveLoadingPodcastData = null;
        }, 10000);
      }
    } catch (e) {
      clearInterval(this.intervalRemoveLoadingPodcastData);
      this.intervalRemoveLoadingPodcastData = null;
    }
  }
}
